export default "__VITE_ASSET__1YsENSv$__"